export const POS_SESSION_KEYS = {
  COUNTER: 'fattahone_selected_counter_id',
  TERMINAL: 'fattahone_selected_terminal_id',
  SHIFT: 'fattahone_active_shift_id',
} as const;

export function clearPosSessionStorage(): void {
  sessionStorage.removeItem(POS_SESSION_KEYS.COUNTER);
  sessionStorage.removeItem(POS_SESSION_KEYS.TERMINAL);
  sessionStorage.removeItem(POS_SESSION_KEYS.SHIFT);
}
